import { render, staticRenderFns } from "./Characters.vue?vue&type=template&id=2b3adafc&scoped=true&"
import script from "./Characters.vue?vue&type=script&lang=js&"
export * from "./Characters.vue?vue&type=script&lang=js&"
import style0 from "./Characters.vue?vue&type=style&index=0&id=2b3adafc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3adafc",
  null
  
)

export default component.exports